import * as ko from "knockout";
import entityBase from "entityBase";
import { CustomObservables } from "CustomObservables";

export class c_sap_sales_order extends entityBase {
  contract_id: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  formattedcreated_dttm: any;
  customer_po: KnockoutObservable<string>;
  delivery_dt: KnockoutObservable<Date>;
  formatteddelivery_dt: any;
  delivery_no: KnockoutObservable<string>;
  delivery_tracking_no: KnockoutObservable<string>;
  invoice_id: KnockoutObservable<string>;
  modified_by: KnockoutObservable<string>;
  modified_dttm: KnockoutObservable<Date>;
  formattedmodified_dttm: any;
  request_id: KnockoutObservable<string>;
  sales_document_type: KnockoutObservable<string>;
  sales_order_no: KnockoutObservable<string>;
  sales_org: KnockoutObservable<string>;
  sap_billing_dt: KnockoutObservable<Date>;
  formattedsap_billing_dt: any;
  sap_invoice_dt: KnockoutObservable<Date>;
  formattedsap_invoice_dt: any;
  sap_invoice_no: KnockoutObservable<string>;
  status: KnockoutObservable<string>;
  status_desc: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  voucher_id: KnockoutObservable<string>;

  constructor(item) {
    super();
    this.contract_id = ko.observable(item.contract_id);
    this.created_by = ko.observable(item.created_by);
    this.created_dttm = ko.observable(this.formatJSONDate(item.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateObservable(this.created_dttm);
    this.customer_po = ko.observable(item.customer_po);
    this.delivery_dt = ko.observable(this.formatJSONDate(item.delivery_dt));
    this.formatteddelivery_dt = CustomObservables.formattedDateObservable(this.delivery_dt);
    this.delivery_no = ko.observable(item.delivery_no);
    this.delivery_tracking_no = ko.observable(item.delivery_tracking_no);
    this.invoice_id = ko.observable(item.invoice_id);
    this.modified_by = ko.observable(item.modified_by);
    this.modified_dttm = ko.observable(this.formatJSONDate(item.modified_dttm));
    this.formattedmodified_dttm = CustomObservables.formattedDateObservable(this.modified_dttm);
    this.request_id = ko.observable(item.request_id);
    this.sales_document_type = ko.observable(item.sales_document_type);
    this.sales_order_no = ko.observable(item.sales_order_no);
    this.sales_org = ko.observable(item.sales_org);
    this.sap_billing_dt = ko.observable(this.formatJSONDate(item.sap_billing_dt));
    this.formattedsap_billing_dt = CustomObservables.formattedDateObservable(this.sap_billing_dt);
    this.sap_invoice_dt = ko.observable(this.formatJSONDate(item.sap_invoice_dt));
    this.formattedsap_invoice_dt = CustomObservables.formattedDateObservable(this.sap_invoice_dt);
    this.sap_invoice_no = ko.observable(item.sap_invoice_no);
    this.status = ko.observable(item.status);
    this.status_desc = ko.observable(item.status_desc);
    this.task_id = ko.observable(item.task_id);
    this.voucher_id = ko.observable(item.voucher_id);
  }
}
